/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { UsersApi } from "client";
import { useUserContext } from "context/UserContext";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { useCallApi } from "./CallApiHook";
import { Const } from "const";
export interface UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

export const useUsers = () => {
  const { jobsite } = useUserContext();
  const [api, canceler] = useApiWithTimeout(
    UsersApi,
    Const.operationTimeout.getUsers
  );

  return useCallApi<UserInfo[]>(
    async () => {
      if (jobsite?.organizationId === undefined) {
        return [];
      }
      // Retrieve materials
      const response = await api.getUsers({
        organizationId: jobsite.organizationId,
      });
      return (
        response.userInfos?.map((user) => {
          return {
            id: user.userId,
            firstName: user.firstName,
            lastName: user.lastName,
            fullName: `${user.firstName} ${user.lastName}`,
          } as UserInfo;
        }) ?? []
      );
    },
    canceler,
    [jobsite?.organizationId, api, canceler]
  );
};
